import {
	formatShortDate,
	formatShortDateTime,
	formatDate,
	formatLocalDate
} from '@/utils/date-functions';

/**
 * @mixin
 */
export default {
	methods: {
		formatShortDate(date) {
			let formatedDate;

			if (date) {
				formatedDate = formatShortDate(date);
			}

			return formatedDate;
		},
		formatShortDateTime(dateTime) {
			let formattedTime;

			if (dateTime) {
				formattedTime = formatShortDateTime(dateTime);
			}

			return formattedTime;
		},
		formatDate(date, dateFormat) {
			let formatedDate;

			if (date) {
				formatedDate = formatDate(date, dateFormat || 'MM/dd/yy');
			}

			return formatedDate;
		},
		formatLocalDate(date, dateFormat) {
			let formatedDate;

			if (date) {
				formatedDate = formatLocalDate(date, dateFormat || 'MM/dd/yy');
			}

			return formatedDate;
		}
	}
};
